import { render, staticRenderFns } from "./suspended.vue?vue&type=template&id=3eaebce6&"
import script from "./suspended.vue?vue&type=script&lang=js&"
export * from "./suspended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports